<app-auth-layout
  [title]="'LOGIN.TITLE' | translate"
>
  <div class="overlay">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
</app-auth-layout>
